<div class="container container-fullsize">
    <div class="row">
      <div class="col card ">
      <div class="col mt-2">
        <div (click)="goBack()" style="cursor: pointer;padding: 2px 20px 0 0;float: left;">
          <i class="fas fa-arrow-left"></i>
        </div>
        <h3 class="card-title text-center float-left"> Cadastro de novo assistente </h3>
      </div>
      <hr>
      <p>Informe os dados solicitados para cadastro de um novo assistente de eleições para o gestor:</p>
      <br>
      <form role="form" [formGroup]="formGroup" (ngSubmit)="onSubmit(formGroup.value)">
        <div class="container">
          <div class="row">
            <div class="col-md-8">
              <strong> Nome completo </strong>
            </div>
            <div class="col-md-4">
              <strong> CPF </strong>
            </div>
          </div>
          <div class="row">
            <div class="col-md-8">
              <input class="form-control ext-input p-8" placeholder="Informe o nome completo do assistente" 
              type="text" formControlName="nome" >
            </div>
            <div class="col-md-4">
              <input class="form-control ext-input p-8" placeholder="Informe o CPF do assistente" 
              type="text" mask="000.000.000-00" formControlName="cpf" >
            </div>
          </div>
          <br>  
          <div class="row">
            <div class="col-sm">
              <strong> E-mail </strong>
            </div>
            <div class="col-sm">
              <strong> Senha </strong>
            </div>
            <div class="col-sm">
              <strong>  </strong>
            </div>
          </div>
          <div class="row">
            <div class="col-md">
              <input class="form-control ext-input p-8" placeholder="Informe o endereço de e-mail do assistente" 
              type="email" formControlName="email" [email]="true">
            </div>
            <div class="col-sm">
              <input [(ngModel)]="senha" class="form-control ext-input p-8" placeholder="Digite a senha de acesso do assistente" 
              type="password" formControlName="senha" >
            </div>
            <div class="col-sm">
              <input [(ngModel)]="confirmacaoSenha" class="form-control ext-input p-8" placeholder="Confirme a senha digitada" 
              type="password" formControlName="confirmacaoSenha" >
            </div>
          </div>
          <span *ngIf="senha != confirmacaoSenha" class="error" style="color: red"> As senhas devem ser iguais!!! </span>
        </div>
        <br>
        
        <div>
            <table>
                <tr>
                <td>
                    <div>
                      <button type="submit" class="btn btn-success">SALVAR</button>
                    </div>
                  </td>
                  <td>
                    
                  </td>
                  <td>
                    <div>
                      <button (click)="goBack()" class="btn btn-danger" > CANCELAR </button>
                    </div>
                </td>       
                </tr>
            </table>
        </div>
        <br>  
        <br>  
      </form>
